import { SparklesIcon } from "./icons.js";

const recoveryByCode: Record<string, { title: string; description: string; steps: string[] }> = {
  SALESFORCE_OAUTH_REQUEST_EXPIRED: {
    title: "本次授权已失效",
    description: "授权链接已过期或已经使用，安全起见不能重复提交。",
    steps: ["关闭当前页面", "返回 Salesforce“AI 助手设置”", "重新点击激活或授权"]
  },
  SALESFORCE_OAUTH_AUTHORIZATION_BLOCKED: {
    title: "Salesforce 暂未允许连接",
    description: "当前用户尚未获准使用 AI 助手授权应用。",
    steps: ["请管理员检查 ECA 预授权策略", "确认当前用户已分配 AI 助手权限集", "返回 Salesforce 重新发起"]
  },
  SALESFORCE_OAUTH_WRONG_ORG: {
    title: "进入了其他 Salesforce Org",
    description: "本次授权不是从当前要激活的 Org 完成的。",
    steps: ["关闭当前页面", "确认已登录目标 Org", "从该 Org 的“AI 助手设置”重新授权"]
  },
  SALESFORCE_OAUTH_ACCESS_DENIED: {
    title: "授权已取消",
    description: "Salesforce 没有将任何权限提交给 AI 助手。",
    steps: ["关闭当前页面", "返回 Salesforce“AI 助手设置”", "如需继续，请重新授权"]
  },
  SALESFORCE_OAUTH_IDENTITY_MISMATCH: {
    title: "授权账号与目标不一致",
    description: "当前登录的 Salesforce 账号不是激活时指定的管理员或绑定用户。",
    steps: ["退出其他 Salesforce 账号", "使用指定管理员登录目标 Org", "从 AI 助手设置页重新发起"]
  }
};

const defaultRecovery = {
  title: "连接尚未完成",
  description: "Salesforce 身份校验或授权交换未完成，系统已停止后续激活。",
  steps: ["关闭当前页面", "返回 Salesforce“AI 助手设置”查看状态", "重新发起激活或授权"]
};

export function SalesforceAuthorizationErrorApp() {
  const code = new URLSearchParams(window.location.search).get("code") ?? "SALESFORCE_OAUTH_CALLBACK_FAILED";
  const recovery = recoveryByCode[code] ?? defaultRecovery;

  return (
    <main className="assistant-activation-shell">
      <section className="assistant-activation-card assistant-activation-card--error" aria-labelledby="salesforce-authorization-error-title">
        <div className="assistant-activation-card__brand">
          <span><SparklesIcon size={26} /></span>
          <div><strong>AI 助手</strong><small>Salesforce 安全连接</small></div>
        </div>
        <p className="assistant-activation-status" role="status">本次未修改 Salesforce 业务数据</p>
        <h1 id="salesforce-authorization-error-title">{recovery.title}</h1>
        <p>{recovery.description}</p>
        <ol className="assistant-activation-steps">
          {recovery.steps.map((step) => <li key={step}>{step}</li>)}
        </ol>
        <button className="button button--primary button--full" type="button" onClick={() => window.close()}>关闭窗口</button>
        <a className="button button--secondary button--full" href="/workspace">转到独立工作台</a>
        <small>错误参考：{code}</small>
      </section>
    </main>
  );
}
